"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterToKeyValueRow = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var searchQueryToUrl_1 = require("@/transformers/searchQueryToUrl");
exports.filterToKeyValueRow = function (filter, lang, currency, t) {
    var formatCurrency = function (price) { return format_1.default.currencyAdvance(price, filter.listingType, lang, false); };
    var rows = [];
    rows.push({ key: t.contract, value: filter.listingType === SfilterTypeGroup_1.ListingPurposeType.Rent ? t.forRent : t.forSale });
    if (filter.keyword) {
        rows.push({ key: t.keyword, value: filter.keyword });
    }
    var selectedDistricts = filter.districts.filter(function (it) { return it.area >= 0 && it.selected; }).map(function (it) { return it.name; });
    if (selectedDistricts.length) {
        var districtValue = selectedDistricts.length > 4 ? selectedDistricts.slice(0, 4).join(', ') + " " + t.andMore : selectedDistricts.join(', ');
        rows.push({ key: t.district, value: districtValue });
    }
    if (filter.priceMin !== 0 || filter.priceMax !== -1) {
        var priceStr = searchQueryToUrl_1.buildPrice(filter.priceMin, filter.priceMax, currency)
            .split('-')
            .slice(1)
            .map(function (it) { return Number(it).toString() === it ? formatCurrency(Number(it)) : it; })
            .join(' ');
        rows.push({ key: t.price, value: priceStr });
    }
    if (filter.sizeMin !== 0 || filter.sizeMax !== -1) {
        var rangeStr = [format_1.default.comma(filter.sizeMin), format_1.default.comma(filter.sizeMax)].join('-');
        if (filter.sizeMin === 0)
            rangeStr = ['<', format_1.default.comma(filter.sizeMax)].join(' ');
        if (filter.sizeMax === -1)
            rangeStr = [format_1.default.comma(filter.sizeMin), '+'].join(' ');
        var size = {
            key: t.size,
            value: rangeStr,
        };
        rows.push(size);
    }
    var selecetedBeds = filter.bedsPresets.find(function (it) { return it.selected; });
    if (selecetedBeds) {
        rows.push({ key: t.beds, value: selecetedBeds.name });
    }
    var selectedAmenities = filter.amenityOptions.filter(function (it) { return it.selected; });
    if (selectedAmenities.length) {
        rows.push({ key: t.amenity, value: selectedAmenities.map(function (it) { return it.name; }).join(', ') });
    }
    var selectedPropertyTypes = filter.typeOptions.filter(function (it) { return it.selected; });
    if (selectedPropertyTypes.length) {
        rows.push({ key: t.type, value: selectedPropertyTypes.map(function (it) { return it.name; }).join(', ') });
    }
    rows.push({ key: t.sort, value: filter.sortOptions.find(function (it) { return it.selected; }).name });
    return rows;
};
